import Wrapper from './styles';
import React, { useState } from 'react';
import { Title, Content, Label, SliderContainer } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { setAge, setFilter } from 'redux/general/actions';
import dataJson from 'shared/data';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';

const FilterSlider = () => {
  const [age, setAgeState] = useState({min: 20, max: 77});
  const dispatch = useDispatch();
  
  const onChange = (e) => {
    setAgeState(e);
  }

  const onChangeComplete = (e) => {
    dispatch(setAge([e.min, e.max]));    
  }

  return(
    <Wrapper>
      <Title>Edad</Title>
      <Content>
        <Label>20</Label>
        <SliderContainer>
          <InputRange 
            minValue={20}
            maxValue={77}
            onChange={onChange}
            onChangeComplete={onChangeComplete}
            value={age}
          />
        </SliderContainer>
        <Label>77</Label>
      </Content>
    </Wrapper>
  )
}

export default FilterSlider;